module.exports = __webpack_public_path__ + "static/work-sefton-5ba209102163e1700b14d951c3c39327.jpg";